import Title from "antd/lib/typography/Title";
import { toTitleCase } from "../../../utils/commonfunction";

const PARENT_COLUMN_VARIATIONS = [
  ["PurchaseOrderTransactionNo", "PurchaseOrderNo", "PONo", "POTransactionNo"],
  ["PurchaseOrderTransactionDate", "PurchaseOrderDate", "PODate"],
  ["PurchaseOrderQty", "POQty", "POQuantity"],
];

const findParentKey = (headList, possibleKeys) => {
  const normalize = (s) => (s || "").toLowerCase().replace(/\s/g, "");
  for (const pk of possibleKeys) {
    const match = headList.find((k) => normalize(k) === normalize(pk));
    if (match) return match;
  }
  return null;
};

export default function PoVsGrnTemp(props) {
  const thCss = {
    border: "1px solid black",
    padding: "6px 12px",
    display: "table-cell",
    color: "black",
  };
  const thCssHead = {
    border: "1px solid black",
    padding: "6px 12px",
    display: "table-cell",
    background: "#4561b9",
    color: "white",
    fontWeight: "bold",
  };
  const headRow = {
    display: "table-row",
    fontWeight: "900",
    color: "#ffffff",
  };

  const list = props?.list || [];
  const headList =
    props.headList || (list.length > 0 ? Object.keys(list[0]) : []);

  const parentColumns = PARENT_COLUMN_VARIATIONS.map((variations) =>
    findParentKey(headList, variations)
  ).filter(Boolean);

  const childColumns = headList.filter((h) => !parentColumns.includes(h));

  const groupedData = list.reduce((acc, row) => {
    const groupKey = parentColumns
      .map((col) => String(row[col] ?? ""))
      .join("|");
    if (!acc[groupKey]) acc[groupKey] = [];
    acc[groupKey].push(row);
    return acc;
  }, {});

  const groups = Object.values(groupedData);

  return (
    <div style={{ border: "1px solid gray", padding: 20, width: "100%" }}>
      <table
        style={{ borderCollapse: "collapse", width: "100%" }}
        id="table-to-xls"
      >
        <tr>
          <td colSpan={headList?.length || 6}>
            <Title level={4} style={{ textAlign: "center" }}>
              PO Vs GRN Report: {props.parentBranch} - {props.parentDepartment}
            </Title>
          </td>
        </tr>

        <tr>
          <td colSpan={headList?.length || 6}>
            <Title level={5} style={{ textAlign: "center" }}>
              {props.date}
            </Title>
          </td>
        </tr>

        {headList?.length > 0 && (
          <tr style={headRow}>
            {parentColumns.map((x) => (
              <td key={x} style={thCssHead}>
                {toTitleCase(x || "")}
              </td>
            ))}
            {childColumns.map((x) => (
              <td key={x} style={thCssHead}>
                {toTitleCase(x || "")}
              </td>
            ))}
          </tr>
        )}

        <tbody>
          {groups.map((group, groupIndex) =>
            group.map((row, rowIndex) => (
              <tr
                key={`${groupIndex}-${rowIndex}`}
                style={{ pageBreakInside: "avoid" }}
              >
                {parentColumns.map((col) =>
                  rowIndex === 0 ? (
                    <td
                      key={col}
                      style={thCss}
                      rowSpan={group.length}
                    >
                      {row[col]}
                    </td>
                  ) : null
                )}
                {childColumns.map((col) => (
                  <td key={col} style={thCss}>
                    {row[col]}
                  </td>
                ))}
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}
